module.exports = __webpack_public_path__ + "img/builds@2x.98c2f7ab.jpg";